/**
 * Returns the first day of the week for the current user's locale.
 *
 * This function uses the `Intl.Locale` API to determine the first day of the week
 * based on the user's browser language settings. It checks for the presence of
 * `getWeekInfo()` or `weekInfo` properties on the `Intl.Locale` object to retrieve
 * the information. If neither is available, it defaults to returning `1` (typically Monday).
 *
 * @returns {number} The numeric representation of the first day of the week (0 = Sunday, 1 = Monday, etc.).
 */
export const firstDayOfWeek = (): number => {
  const locale = new Intl.Locale(navigator.language);

  if (typeof locale.getWeekInfo === 'function') {
    return locale.getWeekInfo().firstDay;
  }

  if ('weekInfo' in locale) {
    return locale.weekInfo.firstDay;
  }

  return 1;
};
